const actions = {
  FETCH_TAGS: 'FETCH_TAGS',
  FETCH_TAGS_SUCCESS: 'FETCH_TAGS_SUCCESS',
  FETCH_TAGS_ERROR: 'FETCH_TAGS_ERROR',
  START_POOLING: 'START_POOLING',
  STOP_POOLING: 'STOP_POOLING',
  TAG_SET_VALUE: 'tag/SET_VALUE',
}

export default actions
